"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingModuleHarnessFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tokenContract",
                type: "address",
            },
        ],
        name: "DisableToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tokenContract",
                type: "address",
            },
        ],
        name: "EnableToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tokenContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "staker",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "StakeToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tokenContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "staker",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "UnStakeToken",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "disableToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "enableToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
        ],
        name: "getCurrentlyStakedTokenIdLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
        ],
        name: "getCurrentlyStakedTokenIds",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getEnabledTokens",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_staker",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "isTokenStaked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "unstake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5061001a3361001f565b61006f565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b610d7e8061007e6000396000f3fe608060405234801561001057600080fd5b50600436106100a45760003560e01c8063150b7a02146100a957806323e27a64146100e657806337099065146100fb578063715018a61461011057806376e8f12f146101185780638da5cb5b1461013b578063a88f15271461015b578063adc9772e1461017c578063c2a672e01461018f578063c690908a146101a2578063cfa025b1146101b5578063f2fde38b146101d5575b600080fd5b6100c86100b7366004610b99565b630a85bd0160e11b95945050505050565b6040516001600160e01b031990911681526020015b60405180910390f35b6100f96100f4366004610b12565b6101e8565b005b6101036101fc565b6040516100dd9190610c7b565b6100f961020b565b61012b610126366004610b5e565b61021f565b60405190151581526020016100dd565b610143610234565b6040516001600160a01b0390911681526020016100dd565b61016e610169366004610b2c565b610243565b6040519081526020016100dd565b6100f961018a366004610c2e565b610258565b6100f961019d366004610c2e565b610266565b6100f96101b0366004610b12565b610270565b6101c86101c3366004610b2c565b610281565b6040516100dd9190610cc8565b6100f96101e3366004610b12565b61028d565b6101f0610308565b6101f981610367565b50565b60606102066103aa565b905090565b610213610308565b61021d60006103b6565b565b600061022c848484610406565b949350505050565b6000546001600160a01b031690565b600061024f8383610437565b90505b92915050565b6102628282610467565b5050565b610262828261048b565b610278610308565b6101f9816105a1565b606061024f83836105e4565b610295610308565b6001600160a01b0381166102ff5760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084015b60405180910390fd5b6101f9816103b6565b33610311610234565b6001600160a01b03161461021d5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016102f6565b610372600282610615565b506040516001600160a01b038216907f3907c2f289c906800bbef774e6e4a476623eae8c1abc6cd0a78ef88aba9a622590600090a250565b6060610206600261062a565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6001600160a01b038084166000908152600160209081526040808320938616835292905290812061022c90836106f4565b6001600160a01b038083166000908152600160209081526040808320938516835292905290812061024f90610700565b8161047360028261070a565b61047c57600080fd5b610486838361071f565b505050565b610496823383610406565b6104d55760405162461bcd60e51b815260206004820152601060248201526f151bdad95b881b9bdd081cdd185ad95960821b60448201526064016102f6565b6001600160a01b03821660009081526001602090815260408083203384529091529020610502908261085c565b50604051632142170760e11b81526001600160a01b038316906342842e0e9061053390309033908690600401610c57565b600060405180830381600087803b15801561054d57600080fd5b505af1158015610561573d6000803e3d6000fd5b50506040518392503391506001600160a01b038516907f663ad82c112f360519adae4e1c42086aed0a55ed23d4b2dd76f16540be17f86090600090a45050565b6105ac600282610868565b506040516001600160a01b038216907f1f4b6598cc34e310cc34bcfcb372afb5ba5af654fad97b26cc10ae8289f1c62f90600090a250565b6001600160a01b03808316600090815260016020908152604080832093851683529290522060609061024f9061087d565b600061024f836001600160a01b038416610930565b6060600061063783610700565b90506000816001600160401b0381111561066157634e487b7160e01b600052604160045260246000fd5b60405190808252806020026020018201604052801561068a578160200160208202803683370190505b50905060005b828110156106ea576106a28582610a4d565b8282815181106106c257634e487b7160e01b600052603260045260246000fd5b6001600160a01b03909216602092830291909101909101526106e381610d17565b9050610690565b509150505b919050565b600061024f8383610a59565b6000610252825490565b600061024f836001600160a01b038416610a59565b6001600160a01b0382166000908152600160209081526040808320338452909152902061074c90826106f4565b156107905760405162461bcd60e51b8152602060048201526014602482015273151bdad95b88185b1c9958591e481cdd185ad95960621b60448201526064016102f6565b604051632142170760e11b81526001600160a01b038316906342842e0e906107c090339030908690600401610c57565b600060405180830381600087803b1580156107da57600080fd5b505af11580156107ee573d6000803e3d6000fd5b5050506001600160a01b0383166000908152600160209081526040808320338452909152902061081f915082610a71565b50604051819033906001600160a01b038516907fdea1edd4ac20c95a9a4c7aebf8a1fee6a435ca363e68539e5d332d86bdc5a73390600090a45050565b600061024f8383610930565b600061024f836001600160a01b038416610a79565b6060600061088a83610700565b90506000816001600160401b038111156108b457634e487b7160e01b600052604160045260246000fd5b6040519080825280602002602001820160405280156108dd578160200160208202803683370190505b50905060005b828110156106ea576108f58582610a4d565b82828151811061091557634e487b7160e01b600052603260045260246000fd5b602090810291909101015261092981610d17565b90506108e3565b60008181526001830160205260408120548015610a43576000610954600183610d00565b855490915060009061096890600190610d00565b90508181146109e957600086600001828154811061099657634e487b7160e01b600052603260045260246000fd5b90600052602060002001549050808760000184815481106109c757634e487b7160e01b600052603260045260246000fd5b6000918252602080832090910192909255918252600188019052604090208390555b8554869080610a0857634e487b7160e01b600052603160045260246000fd5b600190038181906000526020600020016000905590558560010160008681526020019081526020016000206000905560019350505050610252565b6000915050610252565b600061024f8383610ac3565b60009081526001919091016020526040902054151590565b600061024f83835b6000610a858383610a59565b610abb57508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155610252565b506000610252565b6000826000018281548110610ae857634e487b7160e01b600052603260045260246000fd5b9060005260206000200154905092915050565b80356001600160a01b03811681146106ef57600080fd5b600060208284031215610b23578081fd5b61024f82610afb565b60008060408385031215610b3e578081fd5b610b4783610afb565b9150610b5560208401610afb565b90509250929050565b600080600060608486031215610b72578081fd5b610b7b84610afb565b9250610b8960208501610afb565b9150604084013590509250925092565b600080600080600060808688031215610bb0578081fd5b610bb986610afb565b9450610bc760208701610afb565b93506040860135925060608601356001600160401b0380821115610be9578283fd5b818801915088601f830112610bfc578283fd5b813581811115610c0a578384fd5b896020828501011115610c1b578384fd5b9699959850939650602001949392505050565b60008060408385031215610c40578182fd5b610c4983610afb565b946020939093013593505050565b6001600160a01b039384168152919092166020820152604081019190915260600190565b6020808252825182820181905260009190848201906040850190845b81811015610cbc5783516001600160a01b031683529284019291840191600101610c97565b50909695505050505050565b6020808252825182820181905260009190848201906040850190845b81811015610cbc57835183529284019291840191600101610ce4565b600082821015610d1257610d12610d32565b500390565b6000600019821415610d2b57610d2b610d32565b5060010190565b634e487b7160e01b600052601160045260246000fdfea26469706673582212207d665de44fdb42ce40d0ccea0795d7174933b9e2475f231a8559b572c4ebbfc764736f6c63430008030033";
class StakingModuleHarnessFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StakingModuleHarnessFactory = StakingModuleHarnessFactory;
StakingModuleHarnessFactory.bytecode = _bytecode;
StakingModuleHarnessFactory.abi = _abi;
//# sourceMappingURL=StakingModuleHarnessFactory.js.map